import {Component, Inject, Input, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PaymentData } from 'src/app/models/application/payment-data.model';
import { SessionService } from 'src/app/services/session.service';
import {PaymentService} from '../../../services/payment.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
  selector: 'app-add-complements',
  templateUrl: './add-complements.component.html',
  styleUrls: ['./add-complements.component.scss']
})
export class AddComplementsComponent implements OnInit {
  @Input() data: PaymentData;
  /* VARIABLES PARA SABER SI SON MOVILES */
  isMobile: any = false;
  isTablet: any = false;
  constructor(
    private sessionService: SessionService,
    private deviceService: DeviceDetectorService
  ) {
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
  }

  ngOnInit(): void {
  }

  itemHasChanged(): void {
    this.sessionService.updateCartList(this.data, false, null, true);
  }
}
